import {
    mapState,
    mapActions,
    // mapGetters
} from 'vuex'
import viewName from '../constant.js'
import Swiper from '@/components/swiper/swiper.tpl.vue'
import StoreCard from '@/components/storeCard/storeCard.tpl.vue'
import pageNotFound from '../pageNotFound/index.vue'
import Sku from '@/components/sku/sku.tpl.vue'
import QualityImg from '@/components/qualityImg/qualityImg.vue'
import Seckill from '@/components/seckillCard/seckillCard.vue'
import SwiperBox from './components/swiper'
import DeliveryGoodsBox from './components/deliveryGoodsBox'
import SelectedSkuBox from './components/selectedSkuBox'
import GuideBox from './components/guideBox'
import TabsBox from './components/tabsBox'
import GuideFloating from '@/components/guideFloating/guideFloating'
import appGuideDialog from '@/components/appGuideDialog/appGuideDialog'
import onlineCustomerDialog from '@/components/onlineCustomerDialog/onlineCustomerDialog.vue'
// import { getLoginInfo } from '@/utils/loginInfo'

import {
    getMoreSstoreGoodsDetail,
    getMoreSstoreGoodsDetailSpecList
} from '@/models/moreSstoreGoodsDetail'
import {
    setLocalConfig
} from '@/utils/session'
import {
    wxShare,
    // wxSharebyData,
    // wxConfig
} from '@/utils/wxsdk'
import { Cell, Sticky } from 'vant'

import {
    getLocalConfig
} from '@/utils/storage.js'
import _ from 'lodash'
export default {
    inject: ['showLoading', 'hideLoading', 'queryKey'],
    name: viewName.moreSstoreGoodsDetail,
    components: {
        [Sticky.name]: Sticky,
        Swiper,
        StoreCard,
        Sku,
        pageNotFound,
        QualityImg,
        Seckill,
        SwiperBox,
        DeliveryGoodsBox,
        SelectedSkuBox,
        GuideBox,
        TabsBox,
        Cell,
        GuideFloating,
        appGuideDialog,
        'online-Dialog': onlineCustomerDialog
    },
    data () {
        return {
            hasStore: false,
            isPosition: false,
            position: {
                longitude: '',
                latitude: ''
            },
            endStatus: 1, // 1: 默认状态 2: 倒计时为0秒 3: 活动已经结束
            seckillTime: '10',
            current_selectedSkuComb: '',
            curWay: 'store', // 默认的提货方式
            initSku: {}, // 初始化sku值
            skus: {}, // 规格参数
            // tab选择
            tabActive: 0,
            // 选中的规格数据，与数量
            selectedSku: {
                num: 1
            },
            // 标签列表 is_proprietary( 0/1, //  1是自营 0是代理) 自营不显示：邮寄到家，显示到店提货
            tags: [{
                name: '邮寄到家',
                show: false
            },
            {
                name: '厂商直接发货',
                show: false
            },
            {
                name: '到店提取现货',
                show: false
            },
            {
                name: '免费安装',
                show: false
            }
            ],
            detailParams: {},
            // 详情页数据
            detail: null,
            isShowPageNot: false,
            sstore_id: '', // 门店id
            isSellOut: true, // 是否已售罄
            address: '',
            /* 浮动按钮 */
            floatBtn:[
                {
                    key: 'sstores_in',
                    top: '70',
                    right: '10px'
                }
            ]
        }
    },
    watch: {
        detail (val) {
            let tags = this.tags
            // 邮寄到家-支持邮寄的活动分销商品
            tags[0].show = val.delivery_goods.express_status === 1
            // 厂商直接发货-代理商品
            tags[1].show = val.goods.is_proprietary === 0
            // 到店提取现货
            tags[2].show = val.goods.is_proprietary === 1
            // 免费安装 选择门店后，若门店勾选“已包含”安装费，则显示，否则隐藏。点击        弹出窗口，见右图
            tags[3].show = val.delivery_goods.free_install === 1
            this.tags = tags
            this.endStatus = (val.seckill.seckill_status && (val.seckill.seckill_status !== 3)) ? 1 : 3
        },
        isPosition: {
            handler: function (newValue) {
                if (newValue) {
                    this.getAddressData()
                }
            },
            deep: true
        }
    },
    filters: {
        string8 (value) {
            return value.length < 8 ? value : value.substr(0, 8)
        }
    },
    computed: {
        ...mapState({
            isWeixin: ({
                appInfo
            }) => appInfo.isWeixin,
            icarAppInfo: ({ appInfo }) => appInfo.icarAppInfo
        }),
        // ...mapGetters([
        //     'wxUserInfo'
        // ]),
        isMoreThan () {
            return !this.detailParams.sstore_id
        },
        isApp () {
            return this.icarAppInfo.app_name === 'iCar_app'
        },
        seckillClass () {
            // activity_type_id // 2: 特价活动 3: 特价活动
            // endStatus: 1, // 2: 倒计时为0秒 3: 活动已经结束
            // ico-icon_goodsDetail_58 : 限时秒杀
            // ico-icon_goodsDetail_60 : 本轮已结束
            // ico-icon_goodsDetail_57： 已抢光
            if (Number(this.detail.party.activity_type_id) === 2) { // 特价
                if (this.detail.seckill.seckill_stock > 0) {
                    return { 'ico-icon_goodsDetail_61': true }
                } else if (this.detail.seckill.seckill_stock === 0) {
                    return { 'ico-icon_goodsDetail_57': true }
                }
            } else if (Number(this.detail.party.activity_type_id) === 3) { // 秒杀
                if (this.endStatus === 1 && this.detail.seckill.seckill_stock > 0) {
                    return { 'ico-icon_goodsDetail_58': true }
                } else if (this.endStatus === 2 && this.detail.seckill.seckill_stock > 0) {
                    return { 'ico-icon_goodsDetail_60': true }
                } else if (this.detail.seckill.seckill_stock === 0) {
                    return { 'ico-icon_goodsDetail_57': true }
                }
            }
        },
        startText () {
            const type = Number(this.detail.party.activity_type_id)
            let text = ''
            switch (type) {
            // 特价
            case 2:
                text = '距活动开始'
                break
            // 秒杀
            case 3:
                text = '距下一轮开始'
                break
            }
            return text
        },
        endText () {
            const type = Number(this.detail.party.activity_type_id)
            let text = ''
            switch (type) {
            // 特价
            case 2:
                text = '距活动结束'
                break
            // 秒杀
            case 3:
                text = '距本轮结束'
                break
            }
            return text
        }
    },
    async created () {
        this.initLocation()
        /** 页面入参说明
         * spu_id: 商品id
         * sstore_id: 门店id
         * spec_id: b2b_规格id
         * spu_id=10668&sstore_id=1382&spec_id=7454
         */

        // 调取，用于通过code获取用户信息并且保存到本地并且进行绑定手机号码的逻辑
        // await this.getWxUserInfo(this.$route.query.code || '')
        // const pathData = this.$route.path
        // let routequery = this.$route.query
        // routequery['code'] && delete routequery['code'] && this.$router.replace(`${pathData}?${toQueryObject(routequery)}`)
    },
    async mounted () {
        /* 定义页面必传的参数，遍历参数，保存详情路径到本地存储，GOODSDETAIL */
        setLocalConfig('GOODSDETAIL', this.$route.fullPath)
        this.detailParams = this.$route.query
        this.queryKey(this.detailParams, ['spu_id',  'spec_id']).then(_ => {
            this.render({ ...this.detailParams })
            // if (!this.detailParams.sstore_id) {
            //     this.getMyLocation()
            // }
        })

        this.setAppClass({
            isAppend: false,
            className: 'bgGreyColor'
        })
    },
    async activated () {
        if (this.current_selectedSkuComb) {
            let {
                store,
                // goods
            } = this.detail
            let selectedSkuComb = this.current_selectedSkuComb
            // this.apiDetail({
            //     sstore_id: store.sstore_id,
            //     spu_id: selectedSkuComb.spu_id | goods.spu_id,
            //     goods_id: selectedSkuComb.goods_id || goods.goods_id,
            //     goods_type: selectedSkuComb.goods_type || goods.goods_type
            // })
            this.render({
                spu_id: selectedSkuComb.spu_id,
                sstore_id: store.sstore_id,
                spec_id: selectedSkuComb.spec_id
            })
        }
    },
    methods: {
        ...mapActions(['setAppClass', 'getWxUserInfo', 'verifyUserInfo', 'getLocation', 'getAddress', 'saveAddressInfo']),
        // 微信分享
        configWxShare (detail) {
            if (this.isWeixin) {
                wxShare({
                    link: location.href,
                    ...detail
                })
            }
        },
        async render (params) {
            return new Promise(async (resolve, reject) => {
                let response = await this.apiDetail({
                    spec_id: params.spec_id,
                    spu_id: params.spu_id,
                    sstore_id: params.sstore_id,
                    // goods_type: params.goods_type,
                    ...this.position
                })
                // 商品下架跳转逻辑
                if (response.errcode === 6003) {
                    this.$dialog
                        .alert({
                            message: '该商品已下架'
                        }).then(() => {
                            this.$router.go(-1)
                        })
                } else {
                    if (response.goods) {
                        this.detail = response
                        this.seckillTime = response.seckill.seckill_timestamp.toString()
                        this.hasStore = !(this.detail.store instanceof Array)
                        this.apiGoodsSpecList(response)
                        resolve(response)
                    }
                }
            })
        },
        seckillSuccess () {
            const typeId = Number(this.detail.party.activity_type_id)
            // 秒杀
            if (typeId === 3) {
                if (this.detail.seckill.has_next === 0) {
                    this.endStatus = 3
                } else {
                    this.render({ ...this.detailParams }).then(response => {
                        this.endStatus = 1
                        if (response.seckill.seckill_timestamp >= 0) {
                            this.$refs.seckill.start(String(response.seckill.seckill_timestamp))
                        } else {
                            this.endStatus = 3
                        }
                    })
                }
            } else if (typeId === 2) { // 特价
                this.endStatus = this.detail.seckill.seckill_status !== 3 ? this.detail.seckill.seckill_status : 3
            } else {
                this.endStatus = 3
            }
        },
        alertError (message) {
            this.$dialog
                .alert({
                    confirmButtonText: '我知道了',
                    message
                }).then(() => {
                    this.$refs.appGuideDialog.open()
                })
        },
        toggleStore (params) {
            params && Object.assign(this.detailParams, params)
            if (this.isPosition) {
                this.toStoreList()
            } else {
                this.getMyLocation(this.toStoreList)
            }
        },
        toStoreList (params) {
            this.isPosition = true
            const query = {
                ...this.position,
                // sstore_id: this.detailParams.sstore_id || '',
                spec_id: this.detailParams.spec_id,
                spu_id: this.detailParams.spu_id,
                topic_id: this.detailParams.topic_id,
                topic_type: this.detailParams.topic_type,
                page_code: this.detailParams.page_code,
                store_id: this.detailParams.store_id,
                isPosition: this.isPosition,
                ppt_goods_type: this.detailParams.page_code === 'marketingDetail' ? '1' : '', // 备注 特价活动商品详情跳门店列表传1，查的是代理了规格的所有门店
                // activity_id: this.detail.party.activity_id
            }
            params && Object.assign(query, params)
            this.verifyUserInfo({
                type: 'back'
            }).then(_ => {
                this.$router.push({
                    path: '/storeList',
                    query
                })
            })
        },
        toActivityDetail () {
            switch (Number(this.detail.party.activity_type_id)) {
            // case 2:
            //     this.$router.push(`/marketingDetail?topic_id=${this.detailParams.topic_id}&activity_id=${this.detail.seckill.activity_id}`)
            //     break
            case 3:
                this.$router.push(`/seckill?activity_id=${this.detail.seckill.activity_id}`)
                break
            }
        },
        // 打开规格
        open () {
            // const { all_goods_by_stock,  all_goods_by_sstore } = this.detail.goods
            // if (Number(all_goods_by_stock) <= 0 || Number(all_goods_by_sstore) < 0) {
            // } else {
            //     this.$refs.sku.open()
            // }
            this.$refs.sku.open()
        },
        // 关闭规格
        close () {
            this.$refs.sku.close()
        },
        // 请求详情页
        apiDetail (params, type) {
            this.showLoading()
            return new Promise(async (resolve, reject) => {
                getMoreSstoreGoodsDetail(params).then((response) => {
                    // if (type !== 'buyNow') {
                    this.$emit('setHeader', {
                        title: response.goods.goods_name,
                        showHeader: true,
                        showLeft: true
                    })

                    let shareData = {
                        title: response.share.title, // 分享标题
                        desc: response.share.desc, // 分享描述
                        imgUrl: response.share.imgUrl
                    }
                    this.configWxShare(shareData)
                    this.hideLoading()
                    resolve(response)
                }).catch(res => {
                    resolve(res)
                    this.hideLoading()
                })
            })
        },
        // 请求sku规格
        async apiGoodsSpecList (response) {
            let {
                goods,
                // store
            } = response
            const param = {
                // goods_type: this.detailParams.goods_type, // 商品类型（proprietary:自营，agent：代理）
                spec_id: this.detailParams.spec_id, // 商品规格id
                spu_id: this.detailParams.spu_id, // 商品id
            }
            if (Object.values(this.position).every(item => !!item)) {
                Object.assign(param, {
                    sstore_id: this.detailParams.sstore_id || this.detail.store.sstore_id || '', // 门店id
                })
            }
            let skus = await getMoreSstoreGoodsDetailSpecList(param)
            // 初始化sku值用于传入sku组件rr
            this.skus = {
                ...skus
            }

            let img_url = goods.goods_imgs_url[0]

            // 如果是视频就走第二个
            if (img_url.indexOf('mp4') > -1) {
                img_url = goods.goods_imgs_url[1]
            }

            this.initSku = {
                discount: goods.goods_price || 0, // 支付价格
                id: goods.goods_id, // id
                img_url, // 图片
                price: goods.goods_original_price, // 原价
                s1: goods.goods_spec[0], // 默认规格
                s2: goods.goods_spec[1], // 默认规格2
                sku_name: goods.goods_name, // 规格名称
                spu_id: goods.spu_id, // 商品id
                stock_num: goods.goods_stock // 库存
            }
        },
        // 确认
        confirm (e) {
            if (this.skus.sku.none_sku === 1) {
                let {
                    selectedSkuComb
                } = e
                let {
                    goods_id,
                    spu_id,
                } = this.detail.goods
                if (Number(selectedSkuComb.id) !== Number(goods_id)) {
                    this.detailParams.spec_id = selectedSkuComb.spec_id
                    this.render({
                        spu_id: spu_id,
                        sstore_id: this.detailParams.sstore_id || '',
                        spec_id: selectedSkuComb.spec_id,
                    })
                }
                this.close()
            } else {
                this.close()
            }
        },
        // 立即购买
        buyNowToOrder (e) {
            let {
                selectedNum,
                selectedSkuComb,
            } = e
            const { spec_id = this.$route.query.spec_id, spu_id = this.$route.query.spu_id } = selectedSkuComb
            if (!this.isPosition) {
                this.toggleStore({spec_id, spu_id})
            } else {
                this.verifyUserInfo({
                    type: 'back'
                }).then(_ => {
                    if (selectedSkuComb) {
                        // 判断是否有商品数量
                        if (this.detailParams.sstore_id || this.detail.store.sstore_id) {
                        // 保存数据
                            this.setGoodsDetaStorage(selectedNum, selectedSkuComb)
                            this.$router.push({
                                name: 'confirmOrder',
                            })
                            if (this.skus.sku.none_sku === 1) {
                                this.current_selectedSkuComb = selectedSkuComb
                            }
                        } else {
                            this.toStoreList({
                                // sstore_id: this.detailParams.sstore_id || '',
                                spec_id: spec_id,
                                spu_id: spu_id,
                                isPosition: this.isPosition,
                                longitude:  this.position.longitude,
                                latitude:  this.position.latitude,
                            })
                            this.setGoodsDetaStorage(selectedNum, selectedSkuComb)
                        }
                    }
                    // this.confirm(e)
                })
            }
        },
        // 设置存放订单数据
        setGoodsDetaStorage (selectedNum, selectedSkuComb) {
            // const { curWay } = this
            const {
                goods
            } = this.detail
            setLocalConfig('CONFIRM_ORDER', {
                // expressStatus: delivery_goods.express_status === 1,
                // curWay, // 默认的提货方式
                sstore_id: this.detailParams.sstore_id || this.detail.store.sstore_id || '', // 门店id
                topic_id: this.detailParams.topic_id,
                page_code: this.detailParams.page_code,
                goods: [{
                    goods_id: selectedSkuComb.id || goods.goods_id,
                    spec_id: selectedSkuComb.spec_id || goods.spec_id,
                    spu_id: selectedSkuComb.spu_id || goods.spu_id,
                    goods_type: selectedSkuComb.goods_type || goods.goods_type,
                    quantity: selectedNum
                }]
            })
        },
        // 展示免费安装提示信息
        showOperateTips () {
            this.$dialog.alert({
                message: '仅包含按正规操作流程安装本商品时的安装服务费用'
            })
        },
        initLocation () {
            const addressInfo = getLocalConfig('AddressInfo')
            if (addressInfo && !_.isEmpty(addressInfo)) {
                this.address = addressInfo.name
                const position = _.pick(addressInfo, ['longitude', 'latitude'])
                Object.assign(this.position, position)
                this.isPosition = true
            }
        },
        doLocation () {
            if (this.isPosition) {
                this.$router.push(`/selectAddress?city=${this.address}`)
            } else {
                this.getMyLocation()
            }
        },
        getAddressData () {
            if (!this.address) {
                this.getAddress(Object.values(this.position))
                    .then(res => {
                        const param = {
                            longitude: this.position.longitude,
                            latitude: this.position.latitude,
                            province: res.addressComponents.province,
                            city: res.addressComponents.city,
                            district: res.addressComponents.district,
                            name: res.address || '',
                            formattedAddress: res.address
                        }
                        this.address = param.name
                        this.setAddressInfo(param, true)
                    })
            }
        },
        setAddressInfo (params, successStatus) {
            const obj = {
                longitude: this.position.longitude,
                latitude: this.position.latitude,
                province: '广东省',
                city: '广州市',
                district: '白云区',
                name: '广州-同和地铁站',
                formattedAddress: '广州-同和地铁站'
            }
            if (!successStatus) {
                this.address = '广州-同和地铁站'
            } else {
                Object.assign(obj, params)
            }
            this.saveAddressInfo(obj)
        },
        getMyLocation (cb) {
            this.showLoading()
            const options = { timeout: 3000, from: 'noTips' }
            // var geolocation = new qq.maps.Geolocation('3PDBZ-UERCW-ZBORT-OIRZ4-NKWD6-ZMBI6', 'fc')
            // geolocation.getLocation(this.showPosition, this.showErr, options)
            this.getLocation(options)
                .then(this.showPosition)
                .catch(this.showErr)
                .finally(() => {
                    this.isPosition = true
                    this.hideLoading()
                    this.queryKey(this.detailParams, ['spu_id',  'spec_id']).then(_ => {
                        this.render({ ...this.detailParams })
                    })
                })
        },
        /* 获取位置信息成功 */
        showPosition (position) {
            this.position.longitude = position.lng
            this.position.latitude = position.lat
            // this.longitude = 113.326233
            // this.latitude = 23.197102
            this.hideLoading()
        },
        /* 获取位置信息失败，定位失败再请求定位，测试使用 */
        showErr () {
            // 定位同和地铁站
            // this.position.longitude = lng
            // this.position.latitude = lat
            this.position.longitude = 113.326233
            this.position.latitude = 23.197102
            this.setAddressInfo({
                longitude: 113.326233,
                latitude: 23.197102,
                address: '广州-同和地铁站',
                name: '广州-同和地铁站'
            }, false)
            this.hideLoading()
        },
    },
    destroyed () {
        this.hideLoading()
    },
    // beforeRouteLeave (to, from, next) {
    //     // 设置下一个路由的meta
    //     // 如果页面是specialActivity或者marketingDetail是不关闭缓存
    //     // if (to.name !== 'specialActivity' || to.name !== 'marketingDetail') {
    //     //     to.meta.keepAlive = false
    //     // } else {
    //     //     // to.meta.keepAlive =
    //     // }
    //     next()
    // },
}
